import { AdminRouter } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

messageGroups.push('enums')
messageGroups.push('vehicles')
messageGroups.push('company')

AdminRouter.addRoute({
  name: 'vehicle_day_night_pricing',
  path: '/vehicle-day-night-pricing',
  component: () => import('./Index.vue'),
  meta: {
    auth: true,
  },
})
